export const HEADERS = [
  { title: "", checkbox: true, selectAll: false },
  { title: "Project" },
  { title: "Sector" },
  { title: "Status" },
  { title: "Created Date" }
];
